<template>
<div>
    <UFormGroup label="Profile Name" name="name" class="mb-5">
      <UInput v-model="profile.name" />
    </UFormGroup>    

    <UFormGroup label="Email" name="email" class="mb-5">
      <UInput v-model="profile.email" />
    </UFormGroup>    

    <UFormGroup label="Phone" name="phone" class="mb-5">
      <UInput v-model="profile.phone" />
    </UFormGroup>    

</div>
</template>

<script setup lang="ts">
import type { Profile } from '~/common/types/types';

const profile = defineModel({
  required: true,
  type: Object as PropType<Profile>   
})
</script>